module.exports = __webpack_public_path__ + "static/media/shoping_cart.2b124ed8.webp";